// extracted by mini-css-extract-plugin
export default {"wrapper":"about_wrapper__in+Jv","firstBanner":"about_firstBanner__O7reB","content":"about_content__gPVlk","story":"about_story__AnLd-"};